import Celular from "../../assets/images/celular.png";
import Instagram from "../../assets/images/icone-instagram.png";
import GoogleFotos from "../../assets/images/google_fotos.png";
import QrCodeFoto from "../../assets/images/QR_Code.png";
import LineOu from "../../assets/images/Line_ou.png";

const QrCode = () => {
  return (
    <>
      <section id="qr-code">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-4 col-lg-3">
              <img
                src={Celular}
                className="img-fluid d-none d-md-block"
                alt="Líderes do Sucesso Team Edition 2021"
              />
            </div>

            <div className="col-12 col-md-4 col-lg-3 d-flex flex-column gap-3 justify-content-center texto-filtro-lider">
              <h3 style={{ color: "#f89e32", fontWeight: "700" }}>
                Use o filtro Lider
              </h3>

              <a
                aria-current="page"
                href="https://www.instagram.com/premiumclubeoficial/"
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: "none", color: "#fff" }}
              >
                <img
                  src={Instagram}
                  width={40}
                  alt="Instagram Líderes do Sucesso"
                />
                <span>@premiumclubeoficial</span>
              </a>

              <p style={{ color: "#fff" }}>
                Acesse o Instagram da Premium Clube e faça o Download do filtro
                exclusivo do{" "}
                <span style={{ color: "#f89e32", fontWeight: 700 }}>
                  Lideres do Sucesso 2023
                </span>
              </p>
            </div>

            <div className="col-12 col-lg-3 d-none d-lg-block text-center">
              <img src={LineOu} alt="Ou" />
            </div>

            <div className="col-12 col-md-4 col-lg-3 d-flex flex-column align-items-center justify-content-center">
              <img
                src={GoogleFotos}
                alt="Google Fotos"
                width="40%"
                className="mb-2"
              />

              <img src={QrCodeFoto} alt="QR Code" width="60%" />

              <p style={{ width: "250px", color: "#fff", textAlign: "center" }}>
                Use seu celular para ter acesso as fotos do evento e
                <span style={{ color: "#f89e32", fontWeight: 700 }}>
                  {" "}
                  compartilhe com seus amigos.
                </span>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default QrCode;
